import load from '../api/loadFile'
import {FILE_PREVIEW, FILE_PREVIEW_ERROR} from '../lib/constants'

export default function loadSheet(uid) {
    return (dispatch, state) => {
        load(uid)
            .then(sheetData => dispatch({type: FILE_PREVIEW, ...sheetData}))
            .catch(() => dispatch({type: FILE_PREVIEW_ERROR})
            )
    }
}
